<template>
  <div class="servicediv">
    
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>我们的服务</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="server">
      <el-form-item label="品牌代运管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.operate"></el-input>
      </el-form-item> 

      <el-form-item label="英文品牌代运管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.operate_en"></el-input>
      </el-form-item> 

      <el-form-item label="品牌代运管理LOGO" :rules="[
          { required: true, message: '服务LOGO不能为空'},
        ]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          :headers='headers'
          :show-file-list=false
          :on-success="upImgSuccess1"
          multiple
          :limit="3">
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
        </el-upload>
        <div class="QR-code">
          <img width="100%" :src="server.operateimg" alt="">
        </div>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="server">
      <el-form-item label="多模式渠道管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.management"></el-input>
      </el-form-item> 

      <el-form-item label="英文多模式渠道管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.management_en"></el-input>
      </el-form-item> 

      <el-form-item label="多模式渠道管理LOGO" :rules="[
          { required: true, message: '服务LOGO不能为空'},
        ]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          :headers='headers'
          :show-file-list=false
          :on-success="upImgSuccess2"
          multiple
          :limit="3">
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
        </el-upload>
        <div class="QR-code">
          <img width="100%" :src="server.managementimg" alt="">
        </div>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="server">
      <el-form-item label="供应链管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.source"></el-input>
      </el-form-item> 

      <el-form-item label="英文供应链管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.source_en"></el-input>
      </el-form-item>

      <el-form-item label="供应链管理LOGO" :rules="[
          { required: true, message: '服务LOGO不能为空'},
        ]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          :headers='headers'
          :show-file-list=false
          :on-success="upImgSuccess3"
          multiple
          :limit="3">
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
        </el-upload>
        <div class="QR-code">
          <img width="100%" :src="server.sourceimg" alt="">
        </div>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="server">
      <el-form-item label="数据管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.logistics"></el-input>
      </el-form-item> 

      <el-form-item label="英文数据管理" :rules="[
        { required: true, message: '服务内容不能为空'}]">
        <el-input type="textarea" placeholder="服务介绍" v-model="server.logistics_en"></el-input>
      </el-form-item>

      <el-form-item label="数据管理LOGO" :rules="[
          { required: true, message: '服务LOGO不能为空'},
        ]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          :headers='headers'
          :show-file-list=false
          :on-success="upImgSuccess4"
          multiple
          :limit="3">
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
        </el-upload>
        <div class="QR-code">
          <img width="100%" :src="server.logisticsimg" alt="">
        </div>
      </el-form-item>
    </el-form>

     <el-button type="primary" @click="save">保存</el-button>
    <Backfooter></Backfooter>
    </div>
</template>
<script>
import Backfooter from '../../components/dashu/backfooter';
export default {
  components:{Backfooter,},
  data() {
    return {
      server:{
        source: '',
        source_en: '',
        sourceimg: '',
        operate: '',
        operate_en: '',
        operateimg: '',
        management: '',
        management_en: '',
        managementimg: '',
        logistics: '',
        logistics_en: '',
        logisticsimg: '',
      },
      contForm: {
      },
      headers:{
         Authorization: ''
        },
    }
  },
  methods: {
    upImgSuccess1 (response) {
      // console.log(response)
      this.server.operateimg='https://api.treegroup-inc.com/'+response.data.url;
      // console.log(this.server.operateimg)
    },
    upImgSuccess2 (response) {
      // console.log(response)
      this.server.managementimg='https://api.treegroup-inc.com/'+response.data.url;
      // console.log(this.server.managementimg)
    },
    upImgSuccess3 (response) {
      // console.log(response)
      this.server.sourceimg='https://api.treegroup-inc.com/'+response.data.url;
      // console.log(this.server.sourceimg)
    },
    upImgSuccess4 (response) {
      // console.log(response)
      this.server.logisticsimg='https://api.treegroup-inc.com/'+response.data.url;
      // console.log(this.server.logisticsimg)
    },
    save () {
    this.$http.post('/admin/dashu/service/update', {
        id : 1,
        source: this.server.source,
        source_en: this.server.source_en,
        source_image: this.server.sourceimg,
        operate: this.server.operate,
        operate_en: this.server.operate_en,
        operate_image: this.server.operateimg,
        management: this.server.management,
        management_en: this.server.management_en,
        management_image: this.server.managementimg,
        logistics: this.server.logistics,
        logistics_en: this.server.logistics_en,
        logistics_image: this.server.logisticsimg, 
      }).then( (res)=> {
       var code=res.data.code;
       if (code===0){
        this.$message({
          message: '保存成功！',
          type: 'success'
         });
       }else if(code===-1){
          this.$message.error('请检查是否填写完整！');
       }
      }).catch(function (error) {
     });
    }
  },
  created(){
    this.headers.Authorization= window.localStorage.getItem("user_token");
    this.$http.post('/admin/dashu/service/getList', {
      }).then( (res)=> {
          // console.log(res)
       var code=res.data.code;
       if (code===0){
        this.server.source = res.data.data.lists. source;
        this.server.source_en = res.data.data.lists. source_en;
        this.server.sourceimg = res.data.data.lists. source_image;
        this.server.operate = res.data.data.lists. operate;      
        this.server.operate_en = res.data.data.lists.operate_en;     
        this.server.operateimg = res.data.data.lists.operate_image;        
        this.server.management = res.data.data.lists.management;
        this.server.management_en = res.data.data.lists.management_en;
        this.server.managementimg = res.data.data.lists.management_image;
        this.server.logistics = res.data.data.lists. logistics;
        this.server.logistics_en = res.data.data.lists. logistics_en;
        this.server.logisticsimg = res.data.data.lists. logistics_image;
        // console.log(this.server)
       }
      }).catch(function (error) {
     });
  },
  mounted() {
  }
}
</script>
<style> 
.QR-code {
  width: 200px;
}
.el-textarea__inner{
  min-height: 120px !important;
}
 .servicediv{
    position: relative;
    padding-bottom:100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/backPages/services.vue